export enum AddClientFormEnum {
  NotDefined,
  ExistingClient,
  PureClient,
}
